export class WebhookV1ResourceArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerId",
            "baseName": "providerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityScan",
            "baseName": "securityScan",
            "type": "WebhookV1SecurityScan",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1ResourceArguments.attributeTypeMap;
    }
    constructor() {
    }
}
